<div class="ds admin-perms positions-page">
	<div class="wrap">
		<div class="op-head adm-head">
			<button type="button" class="back" routerLink="/admin" [attr.aria-label]="'common.back' | translate"><mat-icon>arrow_back</mat-icon></button>
			<div>
				<p class="eyebrow">{{ "header.menu.admin" | translate }}</p>
				<h1>{{ "positions.title" | translate }}</h1>
				<p class="opx-sub">{{ "positions.desc" | translate }}</p>
			</div>
		</div>

		<!-- Dos flujos independientes: cada ámbito en su tab (decisión Pablo: no mezclarlos) -->
		<div class="perm-tabs">
			<button type="button" class="perm-tab" [class.active]="activeTab === 0" (click)="activeTab = 0">
				<mat-icon [inline]="true">public</mat-icon>
				{{ "positions.general.title" | translate }}
				<span class="tab-badge" *ngIf="generales.length > 0">{{ generales.length }}</span>
			</button>
			<button type="button" class="perm-tab" [class.active]="activeTab === 1" (click)="activeTab = 1">
				<mat-icon [inline]="true">label</mat-icon>
				{{ "positions.porFuncion.title" | translate }}
			</button>
		</div>

		<!-- ============ TAB 1 · Roles generales ============ -->
		<section class="card-block" [hidden]="activeTab !== 0">
			<div class="tab-banner">
				<mat-icon>info</mat-icon>
				<p>{{ "positions.banner.general" | translate }}</p>
			</div>

			<div class="sec-head-row">
				<div>
					<h2 class="block-title">{{ "positions.general.title" | translate }}</h2>
					<p class="block-sub">{{ "positions.general.sub" | translate }}</p>
				</div>
				<button class="btn btn-primary btn-sm" (click)="openCreate()">
					<span class="ic"><mat-icon [inline]="true">add</mat-icon></span>
					{{ "positions.general.new" | translate }}
				</button>
			</div>

			<p *ngIf="!isLoading && generales.length === 0" class="muted">{{ "positions.general.empty" | translate }}</p>

			<table class="perfiles-table" *ngIf="generales.length > 0">
				<thead>
					<tr>
						<th>{{ "positions.col.codigo" | translate }}</th>
						<th>{{ "positions.col.descripcion" | translate }}</th>
						<th>{{ "positions.col.activo" | translate }}</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let p of generales" [class.is-inactive]="p.activo === false">
						<td class="pol-code">{{ p.codigo }}</td>
						<td>{{ p.description }}</td>
						<td><span class="opx-badge" [ngClass]="p.activo === false ? 'gray' : 'ok'">{{ (p.activo === false ? "common.no" : "common.yes") | translate }}</span></td>
						<td class="actions">
							<button type="button" class="link-btn" (click)="openEdit(p)" [matTooltip]="'common.edit' | translate"><mat-icon>edit</mat-icon></button>
							<button type="button" class="link-btn" (click)="toggleActivo(p)" [matTooltip]="(p.activo === false ? 'positions.activate' : 'positions.deactivate') | translate"><mat-icon>{{ p.activo === false ? "toggle_off" : "toggle_on" }}</mat-icon></button>
							<button type="button" class="link-btn" (click)="delete(p)" [matTooltip]="'common.delete' | translate"><mat-icon>delete</mat-icon></button>
						</td>
					</tr>
				</tbody>
			</table>
		</section>

		<!-- ============ TAB 2 · Roles por función ============ -->
		<section class="card-block" [hidden]="activeTab !== 1">
			<div class="tab-banner">
				<mat-icon>info</mat-icon>
				<p>{{ "positions.banner.funcion" | translate }} <span class="muted">{{ "positions.funcionReadonly" | translate }}</span></p>
			</div>

			<div class="sec-head-row">
				<div>
					<h2 class="block-title">{{ "positions.porFuncion.title" | translate }}</h2>
					<p class="block-sub">{{ "positions.porFuncion.sub" | translate }}</p>
				</div>
				<button class="btn btn-primary btn-sm" [disabled]="!selectedFuncion" (click)="openCreate()">
					<span class="ic"><mat-icon [inline]="true">add</mat-icon></span>
					{{ "positions.porFuncion.new" | translate }}
				</button>
			</div>

			<div class="add-row">
				<app-ds-select
					class="assign-select"
					[label]="'positions.porFuncion.pick' | translate"
					[(ngModel)]="selectedFuncion"
					[options]="funciones"
					[optionLabel]="funcionLabelOf"
					[allowEmpty]="true"
				></app-ds-select>
				<span class="muted" *ngIf="selectedFuncion">{{ particulares.length }} {{ "positions.porFuncion.count" | translate }}</span>
			</div>

			<ng-container *ngIf="selectedFuncion">
				<p *ngIf="particulares.length === 0" class="muted" style="margin-top: 12px">{{ "positions.porFuncion.empty" | translate }}</p>

				<table class="perfiles-table" *ngIf="particulares.length > 0" style="margin-top: 12px">
					<thead>
						<tr>
							<th>{{ "positions.col.codigo" | translate }}</th>
							<th>{{ "positions.col.descripcion" | translate }}</th>
							<th>{{ "positions.col.activo" | translate }}</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let p of particulares" [class.is-inactive]="p.activo === false">
							<td class="pol-code">{{ p.codigo }}</td>
							<td>{{ p.description }}</td>
							<td><span class="opx-badge" [ngClass]="p.activo === false ? 'gray' : 'ok'">{{ (p.activo === false ? "common.no" : "common.yes") | translate }}</span></td>
							<td class="actions">
								<button type="button" class="link-btn" (click)="openEdit(p)" [matTooltip]="'common.edit' | translate"><mat-icon>edit</mat-icon></button>
								<button type="button" class="link-btn" (click)="toggleActivo(p)" [matTooltip]="(p.activo === false ? 'positions.activate' : 'positions.deactivate') | translate"><mat-icon>{{ p.activo === false ? "toggle_off" : "toggle_on" }}</mat-icon></button>
								<button type="button" class="link-btn" (click)="delete(p)" [matTooltip]="'common.delete' | translate"><mat-icon>delete</mat-icon></button>
							</td>
						</tr>
					</tbody>
				</table>

				<!-- Vista previa: unión efectiva generales + particulares (solo activos) -->
				<div class="preview">
					<h3 class="sub">{{ "positions.preview" | translate }}</h3>
					<div class="chips">
						<span class="chip" *ngFor="let p of disponiblesPreview" [class.is-general]="p.esGeneral">
							<mat-icon [inline]="true">{{ p.esGeneral ? "public" : "label" }}</mat-icon>
							{{ p.codigo }} · {{ p.description }}
						</span>
						<p *ngIf="disponiblesPreview.length === 0" class="muted">{{ "positions.previewEmpty" | translate }}</p>
					</div>
				</div>
			</ng-container>
		</section>
	</div>
</div>
